import { makeStyles } from '@mui/styles';
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    gap: '26px 32px',
  },
  horizontal: {
    flexDirection: 'row',
  },
  subLabel: {
    paddingLeft: '36px',
    fontSize: '14px',
    fontWeight: '500',
    color: colors.neutral600,
    lineHeight: '20px',
  },
});
